import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import '../parentTables.css';

import { getGatewayPaymentStatus } from '../../api/api';

// Landing page the HDFC gateway returns the parent to after checkout.
// The browser result is never trusted on its own — we ask the backend for the
// real status (backend re-queries HDFC / relies on the webhook), then show it.
const ParentPaymentCallback = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get('order_id');

  const [status, setStatus] = useState('checking'); // checking | success | pending | failed | cancelled
  const [message, setMessage] = useState('Confirming your payment...');

  useEffect(() => {
    let active = true;

    const confirm = async () => {
      if (!orderId) {
        setStatus('failed');
        setMessage('Missing payment reference.');
        return;
      }

      try {
        const result = await getGatewayPaymentStatus(orderId);
        if (!active) return;

        const finalStatus = String(result?.status || 'pending').toLowerCase();
        setStatus(finalStatus);

        if (finalStatus === 'success') {
          setMessage('Your payment was successful. Your fine has been updated.');
        } else if (finalStatus === 'cancelled') {
          setMessage('Your payment was cancelled. No amount was deducted. You can try again from "My Fines".');
        } else if (finalStatus === 'failed') {
          setMessage('Your payment did not go through. No amount was deducted, or it will be refunded.');
        } else {
          setMessage('Your payment is still being confirmed. Please check "My Payments" shortly.');
        }
      } catch (error) {
        if (!active) return;
        setStatus('failed');
        setMessage('We could not confirm your payment. Please check "My Payments" or try again.');
      }
    };

    confirm();
    return () => {
      active = false;
    };
  }, [orderId]);

  const icon =
    status === 'success' ? 'bx-check-circle text-success'
      : status === 'cancelled' ? 'bx-block text-secondary'
        : status === 'failed' ? 'bx-x-circle text-danger'
          : 'bx-time-five text-warning';

  return (
    <div className="container-fluid mt-3 pt-page">
      <div className="card shadow-sm mt-3">
        <div className="card-body text-center py-5">
          {status === 'checking' ? (
            <div className="py-4">Confirming your payment...</div>
          ) : (
            <>
              <i className={`bx ${icon}`} style={{ fontSize: 64 }} />
              <h4 className="mt-3 text-capitalize">Payment {status}</h4>
              <p className="text-muted">{message}</p>
              {orderId && (
                <p className="small text-muted">Reference: {orderId}</p>
              )}
              <div className="mt-4 d-flex gap-2 justify-content-center">
                <button
                  className="btn btn-primary"
                  onClick={() => navigate('/parent-fines')}
                >
                  Back to Fines
                </button>
                <button
                  className="btn btn-outline-secondary"
                  onClick={() => navigate('/parent-payments')}
                >
                  View Payments
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ParentPaymentCallback;
